import React, { useEffect, useState } from "react";
import { Card, Table, Col } from "react-bootstrap";
import PageTitle from "../layouts/PageTitle";
import Spinner from "../common/Spinner";
import Pagination from "../common/Pagination";
import SwitchButton from "../components/ReactSwitch";
import { notifyError, notifyTopRight } from "../common/Toaster";
import {
  getCompanies,
  updateCompanyFlag,
} from "../../services/CompanyFlags/CompanyFlagsService";

export default function AiJobCreation() {
  const [loader, setLoader] = useState(false);
  const [companies, setCompanies] = useState([]);
  const [pageCount, setPageCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [listLength, setListLength] = useState(0);
  const [search, setSearch] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const limit = 10;

  const getTableData = async () => {
    setLoader(true);
    try {
      const response = await getCompanies(currentPage, limit, debouncedSearch);
      const total = response.data.totalRecords || 0;
      setCompanies(response.data.data || []);
      setPageCount(Math.ceil(total / limit));
      setListLength(total);
    } catch (error) {
      notifyError(error?.response?.data?.message || "Failed to load companies");
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    const handle = setTimeout(() => {
      setCurrentPage(0);
      setDebouncedSearch(search);
    }, 500);
    return () => clearTimeout(handle);
  }, [search]);

  useEffect(() => {
    getTableData();
  }, [currentPage, debouncedSearch]);

  const onToggle = async (company, value) => {
    try {
      await updateCompanyFlag({
        _id: company._id,
        aiJobCaptureEnabled: value,
      });
      setCompanies((list) =>
        list.map((c) =>
          c._id === company._id ? { ...c, aiJobCaptureEnabled: value } : c
        )
      );
      notifyTopRight(
        value ? "AI Job Creation enabled." : "AI Job Creation disabled."
      );
    } catch (error) {
      notifyError(error?.response?.data?.message || "Failed to update company");
    }
  };

  return (
    <div>
      <PageTitle activeMenu="AI Job Creation" />
      <Col>
        <Card>
          <Card.Header className="d-block">
            <div className="d-flex justify-content-between align-items-center">
              <div className="col-8" style={{ flexGrow: 1 }}>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <div
                    className="input-group border bg-white input-group-sm"
                    style={{ borderRadius: "8px" }}
                  >
                    <input
                      type="text"
                      name="table_search"
                      className="form-control float-right border-0 search-input"
                      placeholder="Search"
                      value={search}
                      onChange={(e) => setSearch(e.target.value)}
                    />
                  </div>
                </div>
              </div>
            </div>
          </Card.Header>
          <Card.Body>
            {loader ? (
              <Spinner />
            ) : (
              <Table responsive>
                <thead className="text-black">
                  <tr>
                    <th>
                      <strong>COMPANY</strong>
                    </th>
                    <th>
                      <strong>OWNER</strong>
                    </th>
                    <th>
                      <strong>OWNER EMAIL</strong>
                    </th>
                    <th>
                      <strong>AI JOB CREATION</strong>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {companies.map((company) => (
                    <tr key={company._id}>
                      <td>{company.name || "—"}</td>
                      <td>
                        {[company.ownerFirstName, company.ownerLastName]
                          .filter(Boolean)
                          .join(" ") ||
                          company.ownerName ||
                          "—"}
                      </td>
                      <td>{company.ownerEmail || "—"}</td>
                      <td>
                        <SwitchButton
                          initialValue={company.aiJobCaptureEnabled === true}
                          onChange={(value) => onToggle(company, value)}
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            )}
            {companies.length === 0 && !loader && (
              <div className="justify-content-center d-flex my-5">
                Sorry, Data Not Found!
              </div>
            )}
            {companies.length !== 0 && (
              <div className="card-footer clearfix">
                <div className="d-block d-sm-flex justify-content-between align-items-center">
                  <div className="dataTables_info">
                    Showing {currentPage * limit + 1} to{" "}
                    {listLength > (currentPage + 1) * limit
                      ? (currentPage + 1) * limit
                      : listLength}{" "}
                    of {listLength} entries
                  </div>
                  <Pagination
                    pageCount={pageCount}
                    pageValue={currentPage}
                    setPage={setCurrentPage}
                  />
                </div>
              </div>
            )}
          </Card.Body>
        </Card>
      </Col>
    </div>
  );
}
